import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalCustomContentPage: ExperimentalQueries['experimentalCustomContentPage'] =
	async (_, { contentId, contentType, orderBy, start, limit }, { network }) => {
		const params = new URLSearchParams();
		params.append('start', String(start));
		params.append('limit', String(limit));
		params.append('orderby', String(orderBy));

		return fetchJSON(
			network,
			`/wiki/rest/api/content/${contentId}/child/${contentType}?${params}`,
			{
				method: 'GET',
				headers: {
					'Content-Type': MediaType.JSON,
				},
			},
		);
	};

export const experimentalCustomContentProperties: ExperimentalQueries['experimentalCustomContentProperties'] =
	async (_, { contentId }, { network }) => {
		if (!contentId) {
			return {};
		}

		const params = new URLSearchParams();
		params.append('expand', 'metadata.labels,history,operations');

		return fetchJSON(network, `/wiki/rest/api/content/${contentId}?${params}`, {
			method: 'GET',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		});
	};

export const experimentalCustomContentPropertiesPage: ExperimentalQueries['experimentalCustomContentPropertiesPage'] =
	async (_, { contentId, contentType, orderBy, start, limit }, { network }) => {
		let customContentProperties;

		// get all custom content for a page
		try {
			const customContent = await experimentalCustomContentPage(
				_,
				{ contentId, contentType, orderBy, start, limit },
				{ network },
			);

			if (!customContent?.results?.length) {
				return { status: 'fulfilled', results: [] };
			}

			// get all properties for each custom content
			customContentProperties = await Promise.all(
				// @ts-ignore
				customContent.results.map(async ({ id: contentId }) => {
					return await experimentalCustomContentProperties(_, { contentId }, { network });
				}),
			);
		} catch (e) {
			return { status: 'rejected', results: [] };
		}

		return { status: 'fulfilled', results: customContentProperties };
	};
